import { Button, Group, Modal, Stack, Text } from "@mantine/core";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { FormError } from "./Page";

/** ConfirmDialog asks before an action that cannot be undone. */
export function ConfirmDialog({
  opened,
  title,
  children,
  confirmLabel,
  busy,
  error,
  onConfirm,
  onCancel,
}: {
  opened: boolean;
  title: string;
  children: ReactNode;
  confirmLabel: string;
  busy?: boolean;
  error?: string | null;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  const { t } = useTranslation();
  return (
    <Modal
      opened={opened}
      onClose={onCancel}
      title={title}
      centered
      closeButtonProps={{ "aria-label": t("common.close") }}
    >
      <Stack gap="sm" data-testid="confirm-dialog">
        <Text size="sm">{children}</Text>
        <FormError message={error ?? null} />
        <Group justify="flex-end">
          <Button variant="default" onClick={onCancel}>
            {t("common.cancel")}
          </Button>
          <Button color="red" onClick={onConfirm} loading={busy ?? false}>
            {confirmLabel}
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
